var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter18Dp = function SvgTwitter18Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.42063C15.4849 4.66181 14.9313 4.82424 14.3503 4.89746C14.9436 4.52276 15.3992 3.92904 15.6132 3.22149C15.0585 3.5685 14.4437 3.82075 13.7892 3.95673C13.2659 3.36792 12.5187 3 11.6927 3C9.83825 3 8.47558 4.82486 8.89442 6.71924C6.508 6.59311 4.39167 5.3872 2.97475 3.55435C2.22225 4.91591 2.5845 6.69709 3.86317 7.59906C3.393 7.58306 2.94967 7.44709 2.56292 7.22006C2.53142 8.62346 3.48517 9.93642 4.8665 10.2287C4.46225 10.3443 4.0195 10.3714 3.56917 10.2804C3.93433 11.4838 4.99483 12.3593 6.2525 12.3839C5.045 13.3825 3.52367 13.8285 2 13.639C3.27108 14.4986 4.78133 15 6.403 15C11.7358 15 14.7487 10.2496 14.5667 5.98893C15.1279 5.56132 15.615 5.02789 16 4.42063Z",
    fill: "currentColor"
  }))));
};

export { SvgTwitter18Dp as ReactComponent };
export default __webpack_public_path__ + "cd9cd5e2d1c00fa04ebf3aade03f9bce.svg";